<section
  class="bg-(--color-secondary) py-6"
  [class.ltr]="languageService.getLang() === 'en'"
  [class.rtl]="languageService.getLang() === 'ar'"
>
  <div class="px-4 mx-auto max-w-7lg md:px-8">
    <div class="grid grid-cols-1 gap-4 md:grid-cols-3">
      @for (project of projects(); track project.id) {
        <app-project-card
          [project]="project"
          [buttonLabelKey]="'contract_now'"
          (investClick)="onInvest($event)"
        />
      }
    </div>
  </div>
</section>
